import fetcher from 'api/fetcher';

import { Answers, setQuizMessageVisible, setQuizVisible } from 'store/models/quiz';
import { AppThunkAction } from 'store/utils';

interface Result {
    id: string;
    userAnswers: {
        id: string;
        value: string[];
    }[];
}

type SaveQuiz = (
    quizId: string,
    answers: Answers,
    setSaving: (isSaving: boolean) => void,
    fromClose?: boolean
) => AppThunkAction;

export const saveQuiz: SaveQuiz = (quizId, answers, setSaving, fromClose) => {
    return (dispatch, getState) => {
        const { data, isMessageVisible } = getState().quiz;
        const result: Result[] = [];
        Object.entries(answers).forEach(([id, answersId]) => {
            if (answersId.length > 0) {
                result.push({
                    id,
                    userAnswers: answersId.map((answerId) => ({
                        id: answerId,
                        // TODO: пофиксить передачу value
                        value: ['true'],
                    })),
                });
            }
        });
        return fetcher
            .post(`/api/v1/quiz/saveAnswers?eventId=${quizId}`, result)
            .then(() => {
                dispatch(setQuizVisible(false));
                if (fromClose) {
                    if (data?.message) {
                        dispatch(setQuizMessageVisible(true));
                    }
                } else if (isMessageVisible) {
                    dispatch(setQuizMessageVisible(false));
                }
            })
            .finally(() => setSaving(false));
    };
};
